import script from "./LinkedInMessageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkedInMessageView.vue?vue&type=script&setup=true&lang=ts"

import "./LinkedInMessageView.vue?vue&type=style&index=0&id=ae5f9ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae5f9ad4"]])

export default __exports__